var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){return _vm.signIn('email')}}},[_c('i',{staticClass:"material-icons signin-img"},[_vm._v("email")]),_vm._v(" "+_vm._s(_vm.signintext)+" with your e-mail ")])}
var staticRenderFns = []

export { render, staticRenderFns }